import { ApiPath } from "enums";
import { Post } from "utils";

export const generateReport = async (query) => {
  const res = await Post(`${ApiPath.GenerateReport}`, query);
  return res.data;
};
